<template>
  <JadeBox hasPadding>
    <div class="mb-4">
      <JadeText variant="heading-xsmall">
        {{ $t('progress') }}
      </JadeText>
    </div>
    <JadeStatusTracker
      direction="vertical"
      :items="items"
    />
  </JadeBox>
</template>
<script>
import { JadeStatusTracker, JadeBox, JadeText } from '@jade'
import ChargebackDetailsManager from './chargeback-details.manager.js'

export default {
  name: 'ChargebackDetailsTimeline',
  components: { JadeStatusTracker, JadeBox, JadeText },
  props: {
    createdAt: String,
    statusCode: {
      type: Number,
      required: true
    }
  },
  computed: {
    items () {
      return ChargebackDetailsManager.getTimeline(
        this.createdAt,
        this.statusCode
      ).map(timeline => ({ ...timeline, label: this.$t(timeline.label) }))
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
       "progress": "Histórico da contestação",
       "status.notification": "Você recebeu uma contestação",
       "status.waiting-evidences": "Aguardando disputa da contestação",
       "status.in-review": "Sua documentação está em análise",
       "status.in-progress": "Em disputa",
       "status.finalized": "Disputa finalizada"
    },
    "en-US": {
       "progress": "History of the contestation",
       "status.notification": "You have received a dispute",
       "status.waiting-evidences": "Waiting for documentation",
       "status.in-review": "Your documentation is under review",
       "status.in-progress": "In progress",
       "status.finalized": "Dispute completed"
    }
  }
</i18n>
